module.exports = __webpack_public_path__ + "img/pago-efectivo-lg.07b3f06c.png";